import Dashboard from "./Dashboard";

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.ts